import React, { useEffect, useRef } from "react";

// Импортируем изображения (замени на свои)
import alexander from "../img/review/review1.png";
import maria from "../img/review/review2.jpg";
import dmitry from "../img/review/review3.jpg";
import gulmira from "../img/review/review4.jpg";
import artem from "../img/review/review5.png";
import oleg from "../img/review/review6.jpeg";
import victoria from "../img/review/review7.jpg";
import nikolay from "../img/review/review8.jpeg";
import elena from "../img/review/review9.jpg";

// Данные для отзывов
const testimonials = [
  { img: alexander, name: "Александр Смирнов", position: 'Генеральный директор маркетингового агентства "TrendVision" (Россия)', text: "Методология Наргыз Аманбековой – это настоящий прорыв в персонализированной рекламе. Мы внедрили этот подход в 2019 году и увидели колоссальное увеличение конверсии – на 38%! Теперь наши рекламные кампании точечно воздействуют на нужную аудиторию, что снижает затраты и повышает эффективность." },
  { img: maria, name: "Мария Коваленко", position: 'Директор по цифровому маркетингу компании "DigitalDrive" (Украина)', text: "Используем эту методику уже четыре года – результаты впечатляют! Глубокий анализ психотипа пользователей позволяет делать рекламу максимально нативной и адаптированной под каждого клиента. Уровень отклика увеличился на 45%, а стоимость привлечения клиентов снизилась почти на треть." },
  { img: dmitry, name: "Дмитрий Андреев", position: 'основатель рекламного агентства "SmartAd" (Беларусь)', text: "Искусственный интеллект и Big Data меняют маркетинг, и методология Наргыз – лучшее тому подтверждение. Мы наблюдаем рост вовлеченности пользователей на 42% и улучшение качества трафика. Это будущее digital-рекламы, и те, кто внедрит эту технологию сегодня, завтра окажутся на шаг впереди." },
  { img: gulmira, name: "Гульмира Садыкова", position: 'руководитель маркетингового департамента "KazBrand" (Казахстан)', text: 'Когда мы начали использовать этот метод, мы перестали тратить деньги на "слепую" рекламу. Теперь каждое рекламное сообщение подстраивается под характер и предпочтения пользователя. Результат? Вовлеченность выросла на 50%, а продажи – на 28%. Это действительно революция в маркетинге!' },
  { img: artem, name: "Артём Власов", position: 'CEO агентства "AdNext" (Россия)', text: "Классический таргетинг устарел – его заменяют более точные AI-решения. Система, разработанная Наргыз, позволяет выявлять не только интересы, но и эмоциональное состояние пользователей. Это дало нам возможность запускать более релевантные рекламные кампании, увеличив ROI на 35%." },
  { img: oleg, name: "Олег Петров", position: 'директор по стратегическому маркетингу "NewWave Media" (Украина)', text: "Персонализация – главный тренд цифрового маркетинга, и эта методика дает бизнесу точные инструменты для адаптации контента под пользователя. Наши продажи выросли на 30%, а коэффициент отказов на лендингах снизился на 25%!" },
  { img: victoria, name: "Виктория Лазаренко", position: 'директор по маркетингу "MediaPoint" (Казахстан)', text: "Мы работаем с лидерами мнений и знаем, насколько важно понимание психотипа аудитории. Использование этой методологии дало нам возможность создавать рекламу, которая вызывает эмоциональный отклик у клиентов. Это повышение вовлеченности и лояльности, а значит, и стабильный рост продаж" },
  { img: nikolay, name: "Николай Гриневич", position: 'Digital-стратег агентства "NextStep Marketing" (Беларусь)', text: "Использование искусственного интеллекта в анализе контента соцсетей позволяет делать персонализированную рекламу без лишних затрат. Мы уже снизили стоимость лида на 40% и продолжаем масштабировать решения. Это будущее маркетинга!" },
  { img: elena, name: "Елена Радченко", position: 'CMO компании "AdSphere" (Россия)', text: "Рекламные технологии меняются, и ключ к успеху – в глубоком анализе аудитории. Система, основанная на психотипах пользователей, дала нам невероятные результаты: в 2022 году мы увеличили конверсии на 37% и снизили стоимость привлечения клиентов на 25%. Рекомендую всем!" }
];

const Testimonials = () => {
    const scrollers = useRef([]);

    useEffect(() => {
      scrollers.current.forEach((scroller) => {
        let animation = scroller.style.animationPlayState;
  
        scroller.addEventListener("mouseenter", () => {
          scroller.style.animationPlayState = "paused";
        });
  
        scroller.addEventListener("mouseleave", () => {
          scroller.style.animationPlayState = "running";
        });
      });
    }, []);
  
    return (
      <section className="testimonials">
        <div className="testimonials-cont">
          <h2 className="testimonials-title">Отзывы <span>наших клиентов</span></h2>
          <div className="testimonials-wrapper">
            {/* Верхний ряд - двигается влево */}
            <div className="scroll-container scroll-left" ref={(el) => (scrollers.current[0] = el)}>
              {[...testimonials, ...testimonials].map((testimonial, index) => (
                <div key={index} className="testimonial-card">
                  <div className="testimonial-header">
                    <img src={testimonial.img} alt={testimonial.name} className="testimonial-img" />
                    <div>
                      <h4>{testimonial.name}</h4>
                      <p className="testimonial-position">{testimonial.position}</p>
                    </div>
                  </div>
                  <p className="testimonial-text">{testimonial.text}</p>
                </div>
              ))}
            </div>
  
            {/* Нижний ряд - двигается вправо */}
            <div className="scroll-container scroll-right" ref={(el) => (scrollers.current[1] = el)}>
              {[...testimonials, ...testimonials].reverse().map((testimonial, index) => (
                <div key={index} className="testimonial-card">
                  <div className="testimonial-header">
                    <img src={testimonial.img} alt={testimonial.name} className="testimonial-img" />
                    <div>
                      <h4>{testimonial.name}</h4>
                      <p className="testimonial-position">{testimonial.position}</p>
                    </div>
                  </div>
                  <p className="testimonial-text">{testimonial.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  };
  


export default Testimonials;
